import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
    selector: 'td-day',
    template: `
        <ng-template #template>
            <td mat-cell class="block-data block-day {{parity}}">
                <travel-date [beginDate]="beginDate" [quotationOffset]="quotationOffset"></travel-date>
            </td>
        </ng-template>
    `,
    styles: [`
        :host {
            display: none
        }

        td.block-data.block-day {
            font-family: "Roboto Condensed";
            position: sticky;
            z-index: 1;
            left: 10px;
            min-width: 50px;
            max-width: 50px;
            text-align: center;
            padding-left : unset;
            border-right: 1px solid white;
            border-bottom: 1px solid white;
        }

        td.odd {
            background: #ecedef;
        }

        td.even {
            background: #f1f1f1;
        }
    `],
})

export class TdDayComponent implements OnInit {

    @Input()
    public beginDate: string;
    @Input()
    public quotationOffset: number;
    @Input()
    public parity: "odd" | "even" = "odd";

    @ViewChild('template', {read: TemplateRef, static: true})
    public readonly template: TemplateRef<{}>;

    constructor(
        private readonly viewContainerRef: ViewContainerRef
    ) {
    }

    public ngOnInit(): void {
        this.viewContainerRef.createEmbeddedView(this.template);
    }
}
